<template>
  <div>
    <div
      v-if="isSiteLoadDone && bodyBuilderFooterOfferList.length > 0"
      class="ui-content"
    >
      <candy-bar
        :title="$t('shopbuilder_offers')"
        :product-list="bodyBuilderFooterOfferList"
      />
    </div>
    <template v-if="isSiteLoadDone">
      <div v-if="footer.topLeftText !== '' || footer.topRightText !== ''" class="d-flex flex-wrap footer-top-text-row">
        <div class="col-6 footer-top-text-col" v-html="footer.topLeftText" />
        <div class="col-6 footer-top-text-col" v-html="footer.topRightText" />
      </div>
    </template>
    <div v-if="isSiteLoadDone && isFooterExists" class="footer-wrapper">
      <div class="container-xl">
        <!-- Slogen -->
        <div class="text-center slogen-text text-uppercase" v-text="footer.slogen" />
        <div v-if="footer.isMailSubscriberVisible" class="row mb-5">
          <div class="col-12 d-flex justify-content-center">
            <news-letter-subscribe-widget
              :is-default-open="footer.isEmailBoxDefaultOpen"
            />
          </div>
        </div>
        <div class="row">
          <!-- Builder Főmenük -->
          <div class="main-menu-wrapper col-12 col-lg-4">
            <template v-if="footer.leftItemList.length !== 0">
              <!--      Azt mondták nem kell ez a title, kivesszük, és ha jóvá lesz hagyva majd akkor töröljük        -->
              <!--              <div class="footer-title-text" v-text="siteName" />-->
              <ul>
                <li
                  v-for="footerItem in footer.leftItemList"
                  :key="footerItem.id"
                  class="footer-list-item"
                >
                  <!-- eslint-disable vue/no-v-html v-html, mert nagyon sokadik kérésre is kérték, hogy html-t tudjanak ezekbe irni.. -->
                  <a
                    v-if="footerItem.isOuterLink || footerItem.isPhoneNumber || footerItem.isEmail"
                    :href="footerItem.link"
                    :rel="footerItem.isNoFollow ? '' : 'nofollow'"
                    :target="footerItem.isOuterLink ? '_blank' : '_self'"
                    v-html="footerItem.name"
                  />
                  <router-link
                    v-else-if="footerItem.link !== null"
                    :to="footerItem.link"
                    v-html="footerItem.name"
                  />
                  <span
                    v-else
                    v-html="footerItem.name"
                  />
                  <!-- eslint-enable vue/no-v-html v-html, mert nagyon sokadik kérésre is kérték, hogy html-t tudjanak ezekbe irni..  -->
                </li>
              </ul>
            </template>
          </div>
          <!-- Segítség -->
          <div class="main-menu-wrapper col-12 col-lg-4">
            <template v-if="footer.middleItemList.length !== 0">
              <!--      Azt mondták nem kell ez a title, kivesszük, és ha jóvá lesz hagyva majd akkor töröljük        -->
              <!--              <div v-t="'help'" class="footer-title-text" />-->
              <ul>
                <li
                  v-for="footerItem in footer.middleItemList"
                  :key="footerItem.id"
                  class="footer-list-item"
                >
                  <!-- eslint-disable vue/no-v-html v-html, mert nagyon sokadik kérésre is kérték, hogy html-t tudjanak ezekbe irni.. -->
                  <a
                    v-if="footerItem.isOuterLink || footerItem.isPhoneNumber || footerItem.isEmail"
                    :href="footerItem.link"
                    :rel="footerItem.isNoFollow ? '' : 'nofollow'"
                    :target="footerItem.isOuterLink ? '_blank' : '_self'"
                    v-html="footerItem.name"
                  />
                  <router-link
                    v-else-if="footerItem.link !== null"
                    :to="footerItem.link"
                    v-html="footerItem.name"
                  />
                  <span
                    v-else
                    v-html="footerItem.name"
                  />
                  <!-- eslint-enable vue/no-v-html v-html, mert nagyon sokadik kérésre is kérték, hogy html-t tudjanak ezekbe irni..  -->
                </li>
              </ul>
            </template>
          </div>
          <!-- Kövess minket -->
          <div class="main-menu-wrapper col-12 col-lg-4">
            <template v-if="footer.rightItemList.length !== 0">
              <!--      Azt mondták nem kell ez a title, kivesszük, és ha jóvá lesz hagyva majd akkor töröljük        -->
              <!--              <div v-t="'follow_us'" class="footer-title-text" />-->
              <ul>
                <li
                  v-for="footerItem in footer.rightItemList"
                  :key="footerItem.id"
                  class="footer-list-item"
                >
                  <!-- eslint-disable vue/no-v-html v-html, mert nagyon sokadik kérésre is kérték, hogy html-t tudjanak ezekbe irni.. -->
                  <a
                    v-if="footerItem.isOuterLink || footerItem.isPhoneNumber"
                    :href="footerItem.link"
                    :rel="footerItem.isNoFollow ? '' : 'nofollow'"
                    :target="footerItem.isOuterLink ? '_blank' : '_self'"
                    v-html="footerItem.name"
                  />
                  <router-link
                    v-else-if="footerItem.link !== null"
                    :to="footerItem.link"
                    v-html="footerItem.name"
                  />
                  <span
                    v-else
                    v-html="footerItem.name"
                  />
                  <!-- eslint-enable vue/no-v-html v-html, mert nagyon sokadik kérésre is kérték, hogy html-t tudjanak ezekbe irni..  -->
                </li>
              </ul>
            </template>
            <shop-finder v-if="footer.isShopFinderActive" />
          </div>
          <div v-if="footer.socialItemList.length > 0" class="d-flex justify-content-center w-100 my-3">
            <div v-for="(socialIcon, index) in footer.socialItemList" :key="'social-' + socialIcon.name + '-' + index">
              <a
                :href="socialIcon.link"
                :title="socialIcon.name"
                target="_blank"
                @click="sendSocialGaEvent(socialIcon.contentType)"
              >
                <div :class="`social-icon ${socialIcon.contentType}`" />
              </a>
            </div>
          </div>
          <div class="row social-bottom-wrapper w-100">
            <div class="col-12 col-lg-6 d-flex d-lg-block justify-content-center bottom-text" v-html="footer.bottomLeftText" />
            <div class="col-12 col-lg-6 d-flex text-center text-lg-right d-lg-block justify-content-center bottom-text" v-html="footer.bottomRightText" />
          </div>
        </div>
      </div>
    </div>
    <router-link
      id="back-to-top"
      v-b-tooltip.hover.left="$t('ugras_a_lap_tetejere')"
      :to="$route.fullPath"
      class="btn btn-primary up-btn btn-lg back-to-top"
      :aria-label="$t('ugras_a_lap_tetejere')"
      @click.native="scrollToTop"
    >
      <div class="pt-2 pb-1">
        <div
          class="icon-arrow arrow-up mt-1"
          aria-hidden="true"
        />
      </div>
    </router-link>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { BImgLazy, VBTooltip } from 'bootstrap-vue'
import Vue from 'vue'
import ShopFinder from '../shopFinder/shopFinder.vue'

Vue.directive('b-tooltip', VBTooltip)

export default {
  name: 'FooterComponent',
  components: {
    ShopFinder,
    'candy-bar': () => import(/* webpackChunkName: "CandyBar" */ '../CandyBar/CandyBar.vue'),
    'news-letter-subscribe-widget': () => import(/* webpackChunkName: "NewsLetterSubscribeWidget" */ '../NewsLetterSubscribeWidget/NewsLetterSubscribeWidget.vue'),
    'b-img-lazy': BImgLazy,
  },
  computed: {
    /**
     * index oldalon vagyunk-e? ha igen van olyan rész ami csak ott kell megjelenjen (jelengleg ez mindig false lesz, mert az index még nem Vue)
     */
    isIndexPage() {
      return this.$route.fullPath === '/'
    },
    ...mapGetters({
      site: 'Site/getSite',
      isSiteLoadDone: 'Site/isSiteLoadDone',
      siteName: 'Site/getSiteName',
      bodyBuilderFooterOfferList: 'Site/getBodyBuilderFooterOfferList',
      isFooterExists: 'Site/getIsFooterExists',
      footer: 'Site/getFooter',
    }),
  },
  mounted() {
    document.addEventListener('scroll', this.setScrollToTopVisibility)
  },
  destroyed() {
    document.removeEventListener('scroll', this.setScrollToTopVisibility)
  },
  methods: {
    /**
     * scrollozáskor ha kell a scroll to top megjelenitése vagy elrejtése
     */
    setScrollToTopVisibility() {
      // tester page-n nincs, nem is kell
      if (document.getElementById('back-to-top') === null) {
        return
      }
      if (window.scrollY > 50) {
        document.getElementById('back-to-top').style.display = 'block'
      } else {
        document.getElementById('back-to-top').style.display = 'none'
      }
    },
    /**
     * scroll to top
     */
    scrollToTop() {
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth',
      })
    },
    /**
     * social event GA küldése
     *
     * @param key
     */
    sendSocialGaEvent(key) {
      ga('send', 'event', 'Click', 'Kikattintás', key)
    },
  },
}
</script>

<style scoped lang="scss">
.back-to-top {
  cursor: pointer;
  position: fixed;
  bottom: 20px;
  right: 20px;
  display: none;
  z-index: 1;
}

.builder-logo-footer {
  width: 200px;
  height: 95px;
}

.footer-top-text-row {
  padding: 48px 0;
  background-color: #e0e4e6;
  color: #36474e;

  .footer-top-text-col {
    padding: 0px 32px;
    font-size: 12px;

    ::v-deep a {
      color: #74adee;

      &:hover {
        text-decoration: underline;
      }
    }
  }
}

.footer-wrapper {
  background-color: #111;
  color: #fff;
  padding: 56px 0;

  .slogen-text {
    font-weight: 800;
    font-size: 32px;
    padding-bottom: 48px;
    font-style: italic;
  }

  .main-menu-wrapper {
    @media only screen and (max-width: 991px) {
      padding-bottom: 24px;
    }
  }

  ul {
    list-style-type: none;
    padding-left: 0;
  }

  .footer-title-text {
    font-size: 14px;
    font-weight: 500;
    line-height: 16px;
    padding-bottom: 32px;
    text-transform: uppercase;

    @media only screen and (max-width: 991px) {
      padding-bottom: 24px;
    }
  }

  .footer-list-item {
    font-size: 14px;
    line-height: 16px;
    font-weight: 500;
    padding-bottom: 16px;

    a {
      color: #fff;
    }

  }

  // TODO: ez csak addig kell, amíg a storeból kapott html az első oszlop
  /deep/ .store-text-wrapper p {

    font-size: 14px;
    line-height: 16px;
    font-weight: 400;

    br {
      margin-bottom: 16px;
    }

    a {
      color: #fff;

      b {
        font-weight: 400;
      }
    }

    span {
      font-size: 14px;
      font-weight: 600;
    }
  }

  .social-icon {
    width: 36px;
    height: 36px;
    margin: 0 8px;
    background-repeat: no-repeat;
    background-size: 100%;

    &.facebook {
      background-image: url("../../assets/socialIcons/facebook.svg");
    }

    &.instagram {
      background-image: url("../../assets/socialIcons/instagram.svg");
    }
    &.linkedin {
      background-image: url("../../assets/socialIcons/linkedin.svg");
    }

    &.pinterest {
      background-image: url("../../assets/socialIcons/pinterest.svg");
    }

    &.spotify {
      background-image: url("../../assets/socialIcons/spotify.svg");
    }

    &.tiktok {
      background-image: url("../../assets/socialIcons/tiktok.svg");
    }

    &.twitter {
      background-image: url("../../assets/socialIcons/twitter.svg");
    }

    &.youtube {
      background-image: url("../../assets/socialIcons/youtube.svg");
    }
  }

  .bottom-text {
    margin: 20px 0;
  }
  .social-bottom-wrapper {
    margin: 20px;
    border-top: 1px solid #fff;
  }
}
</style>
